import * as React from "react";
const SvgMark = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 8, viewBox: "0 0 10 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9 1L3.5 6.5L1 4", stroke: "#3E54B8", strokeWidth: 1.6666, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgMark;
